import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getInventoryLogReport, getCsvReport } from 'actions/ReportsAction';
import { getProductTypes } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
import { ReportInventoryLogCrumb } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class InventoryLogReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 50,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `InventoryLogBeginDate`);
        this.props.formInput(date, `InventoryLogEndDate`);
        this.props.getProductTypes();
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let productId = this.props.selectProductId || 0;
        let isCannabis = this.props.selectIsCannabis;
        let categoryId = this.props.selectCategoryId;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/inventoryLog?branchId=${branch}&beginDate=${beginDate}&endDate=${endDate}&pageNumber=1&pageSize=9999&productId=${productId}&isCannabis=${isCannabis}&categoryId=${categoryId}`, "InventoryLog");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.categoryId
            };
        });
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let productId = this.props.selectProductId || 0;
        let isCannabis = this.props.selectIsCannabis;
        let categoryId = this.props.selectCategoryId;
        this.props.getInventoryLogReport({ beginDate, endDate, pageNumber, pageSize, branchId, productId, isCannabis, categoryId });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.inventoryLog.length > 0 ? this.props.inventoryLog[0].totalRow : 0;

        return (
            <Grid headerContent={ReportInventoryLogCrumb}>
                <PageHeader title={LOOKUP.report.InventoryLog.text}
                    description={LOOKUP.report.InventoryLog.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    products={this.getProductOptions()}
                    categoryOptions={this.props.categoryOptions}
                    isCannabisOptions={this.props.isCannabisOptions}
                    isCannabis={this.props.selectIsCannabis}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.inventoryLog &&
                    <CardSimple>
                        <Body
                            inventoryLog={this.props.inventoryLog}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let categories = [];
    const cat = state.entity.productTypesList.length > 0 ? state.entity.productTypesList[0].categories : [];
    cat.map(item => {
        categories.push({
            text: item.name,
            value: item.id.toString(),
            isCannabis: item.isCannabis
        });
    });

    categories.sort((a, b) => {
        if (a.text < b.text)
            return -1;
        if (a.text > b.text)
            return 1;
        return 0;
    });

    categories.unshift({ text: "All", value: "0", isCannabis: false }, { text: "All", value: "0", isCannabis: true });

    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];


    return {
        brachOptions: brachOptions,
        inventoryLog: state.reports.inventoryLog,
        loggedBranch: state.common.branchId,
        beginDate: state.form.InventoryLogBeginDate,
        endDate: state.form.InventoryLogEndDate,
        branch: state.form.InventoryLogBranchOption,
        selectProductId: state.form.InventoryLogProductId,
        selectIsCannabis: state.form.InventoryLogIsCannabis,
        selectCategoryId: state.form.InventoryLogSelectedCategory,
        products: state.entity.productList,
        categoryOptions: categories,
        isCannabisOptions: isCannabis
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getInventoryLogReport: model => dispatch(getInventoryLogReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(InventoryLogReport));